export const Breadcrumb = {
  fetchBreadcrumb: '/webapi/Breadcrumb/Get',
};

export const Footer = {
  fetchFooter: '/api/footer',
};

export const CountrySelector = {
  fetchCountrySelectList: '/webapi/CountrySelector/Get',
};

export const RelatedTabs = {
  fetchRelatedTabs: '/webapi/RelatedTabs/Get',
  relatedTabs: '/webapi/RelatedTabs/GetTabs', // NOT IN USE
};

export const Search = {
  doSearch: '/webapi/SearchApi/SearchFor',
  doSearchAutocomplete: '/webapi/SearchApi/GetAutocomplete',
};

export const NewsAndStories = {
  fetchNewsAndStoriesData: '/webapi/NewsListingApi/GetNewsListItems',
  fetchNews: '/webapi/NewsListingApi/GetNewsList',
  fetchStories: '/webapi/StoriesList/Get',
};

export const Webinars = {
  fetchWebinarBanner: '/webapi/WebinarLandingPage/Get',
  fetchWebinarList: '/webapi/WebinarPage/Get',
};

export const Header = {
  fetchHeader: '/webapi/Header/Get', //NOT IN USE
  fetchSubNavigation: '/webapi/SubNavigation/Get',
  fetchMegaMenuNavigation: '/api/mainmenu',
  fetchGeolocation: '/api/Geolocation',
  fetchTopMenu: '/api/TopNavigation/',
  fetchMegaMenuColumn: '/webapi/menuitems/columns',
};

export const Stories = {
  fetchStories: '/webapi/StoriesList/Get',
};

export const News = {
  fetchNews: '/webapi/NewsListPage/Get',
};

export const Vacancies = {
  fetchVacancies: '/webapi/Vacancy/Get', // NOT IN USE
};

export const Webshop = {
  fetchWebshop: '/webapi/WebShop/Get', // NOT IN USE
};

export const ContactUs = {
  fetchContactUsForm: '/webapi/ContactUsForm/GetForm',
  fetchFindOfficeData: '/webapi/CountriesCategories/Get',
  fetchEnquiryForm: '/webapi/contactus/getenquiryform',
  fetchEnquirySerialLinkData: '/webapi/contactus/GetModalPopUp',
  submitEnquiryForm: '/Quote/ProcessForm',
  fetchEnquiryApplicationList: '/webapi/contactus/GetIndustryApplication',
};

export const InvestorRelations = {
  fetchPressReleaseFilterData: '/api/v1/ir/pressrelease',
  fetchInvestorRelationsNews: '/api/v1/ir/news',
  fetchInvestorRelationsPage: '/api/v1/ir/page2',
  fetchInvestorRelationsMenu: '/api/v1/ir/menu2',
  makeSubscription: '//publish.ne.cision.com/Subscription/SubscribeWithCaptcha',
};

export const CoolCalc = {
  getCoolCalc: '/webapi/CoolCalc/Get', // NOT IN USE
  shareCoolCalc: '/webapi/CoolCalc/Save',
};

export const Hexpert = {
  fetchHexpertPage: '/api/v1/hex/page',
  getAntiForgeryToken: '/api/v1/hex/GetAntiForgery',
  submitHexpertForm: '/EPiServer.Forms/DataSubmit/Submit',
  createHexpertPdf: '/api/v1/hex/CreatePdf',
  getIsMatchingProducts: '/api/v1/hex/IsMatchingProduct',
  getHexpertResult: '/api/v1/hex/GetResult',
  mailResult: '/api/v1/hex/SendMail',
};

export const SafetyDatasheet = {
  fetchSafetyDatasheet: '/webapi/SafetyDataSheet/GetSafetyDataSheetResult',
};
